import { useTranslation } from 'react-i18next'

import Icon from '../Icon'
import { CTAButtons, Description, HeroWrapper, PrimaryButton, Title } from './styles'

const Hero = () => {
  const { t } = useTranslation()

  return (
    <HeroWrapper>
      <Title
        dangerouslySetInnerHTML={{
          __html: t('title').replace(/\n/g, '<br>'),
        }}
      />
      <Description
        dangerouslySetInnerHTML={{
          __html: t('description').replace(/\n/g, '<br>'),
        }}
      />
      <CTAButtons>
        <div className="btn">
          <PrimaryButton href="https://chromewebstore.google.com/category/extensions?hl=zh-cn&pli=1" target="_blank">
            <Icon type="chrome" />
            {t('addToChrome')}
          </PrimaryButton>
        </div>
      </CTAButtons>
    </HeroWrapper>
  )
}

export default Hero
